import { render, staticRenderFns } from "./StatisticsDashboard.vue?vue&type=template&id=52542241&scoped=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=js"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDashboard.vue?vue&type=style&index=0&id=52542241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52542241",
  null
  
)

export default component.exports